import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import usersApi from "../../api/userApi";
import Pagination from "../../components/Pagination";
import AssignFranchiseModal from "./AssignFranchiseModal";

const NonReferredCustomersList = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  useEffect(() => {
    fetchUsers();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const fetchUsers = async () => {
    try {
      const response = await usersApi.getNonReferredCutomers(
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      );
      setUsers(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
      setTotalPages(0);
      console.error("Error fetching users", error);
    }
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("userCreditListAdmin", selectedPage);
  };
  const handleAssignClick = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };
  return (
    <>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.userId}>
              <td>{user.userId}</td>
              <td>{user.userName}</td>
              <td>{user.userEmail}</td>
              <td>{user.countryName}</td>
              <td>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => handleAssignClick(user)}
                >
                  Assign to Franchise
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {users.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
      <AssignFranchiseModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        selectedUser={selectedUser}
        onSuccess={fetchUsers}
      />
    </>
  );
};

export default NonReferredCustomersList;
